export default __webpack_public_path__ + "static/media/testmonials-group.8c42c566.webp";